
import React, { memo } from 'react';

import { Form,Input } from 'antd';
import {
  WrapInput
} from './style'


export default memo(function InputCpn(props) {
  const { rules } = props
  const { title,inputType,fId } = props.info

  const typeFormat = (inputType)=>{
    switch (inputType) {
      case '2':
        return inputType = 'email'
      case '3':
        return inputType = 'tel'
      default:
        return inputType = 'text'
    }
  }
  return (
    <WrapInput>
      <Form.Item
        label={title} name={'fId'+fId} rules={rules} validateTrigger={'onBlur'}>
        <Input type={typeFormat(inputType)} />
      </Form.Item>
      
    </WrapInput>
  )
})
